export default __webpack_public_path__ + "static/media/840.df3df8ee.png";